import { NatureOperationId } from '@lib/models/graphqlData';

export type ProjetInvestissementUiPolicy = {
  showOperationsAnnexes: boolean;
  showVersementBlock: boolean;
  showModeDeGestionBlock: boolean;
  showAllocationBlock: boolean;
  showStandaloneAllocationBlock: boolean;
  showMotivationOperationBlock: boolean;
};

const defaultPolicy: ProjetInvestissementUiPolicy = {
  showOperationsAnnexes: true,
  showVersementBlock: true,
  showModeDeGestionBlock: true,
  showAllocationBlock: true,
  showStandaloneAllocationBlock: false,
  showMotivationOperationBlock: false,
};

const policyByNatureOperation: Partial<Record<NatureOperationId, ProjetInvestissementUiPolicy>> = {
  [NatureOperationId.ArbitrageLibre]: {
    showOperationsAnnexes: false,
    showVersementBlock: false,
    showModeDeGestionBlock: false,
    showAllocationBlock: false,
    showStandaloneAllocationBlock: true,
    showMotivationOperationBlock: true,
  },
  [NatureOperationId.ChangementModeGestion]: {
    showOperationsAnnexes: false,
    showVersementBlock: false,
    showModeDeGestionBlock: true,
    showAllocationBlock: true,
    showStandaloneAllocationBlock: false,
    showMotivationOperationBlock: true,
  },
};

export function getProjetInvestissementUiPolicy(
  natureOperationId: number | null | undefined
): ProjetInvestissementUiPolicy {
  if (natureOperationId == null) {
    return defaultPolicy;
  }

  return policyByNatureOperation[natureOperationId as NatureOperationId] ?? defaultPolicy;
}
